import { render, staticRenderFns } from "./TabsSarpras.vue?vue&type=template&id=e1d17d1a&scoped=true&"
import script from "./TabsSarpras.vue?vue&type=script&lang=js&"
export * from "./TabsSarpras.vue?vue&type=script&lang=js&"
import style0 from "./TabsSarpras.vue?vue&type=style&index=0&id=e1d17d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d17d1a",
  null
  
)

export default component.exports